<template>
  <div style="width: 100%;">
    <v-snackbar
      :timeout="3000"
      :value="true"
      absolute
      top
      color="success"
      right
      text
      v-if="appear"
    >
      New staff recorded
    </v-snackbar>
    <v-app>
      <NewStaff :staffModal="showup" @offModal="cancel($event)" @getResponse="getData($event)"></NewStaff>
      <v-dialog
        v-model="dialogModal"
        max-width="500px"
        :persistent="true"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Change privilege</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-select
                    v-model="privilege"
                    label="choose privilege"
                    name="Privilege"
                    v-validate="'required'"
                    :items="selected"
                  ></v-select>
                  <span style="color: red;"
                    v-show="errors.has('Privilege')" v-if="valid">{{ errors.first('Privilege') }}</span>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="offModal"
            >
              Cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="edit('privilege')"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="modal2"
        max-width="500px"
        :persistent="true"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Change Country</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-select
                    v-model="country"
                    label="choose Country"
                    name="Country"
                    v-validate="'required'"
                    :items="countries"
                  ></v-select>
                  <span style="color: red;"
                    v-show="errors.has('Privilege')">{{ errors.first('Privilege') }}</span>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="quitModal"
            >
              Cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="edit('country')"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :options.sync="options"
        :server-items-length="totalDesserts"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:item.id="{item}">
          <v-chip small :color="`#9c9c9c`" style="color: white; font-weight: 600; width: 25px; padding: 8px;">
            {{desserts.map(function(x) {return x.id; }).indexOf(item.id)+1}}
          </v-chip>
        </template>
        <template v-slot:item.names="{ item }">
          <input type="text" style="width: auto;" :value="item.names" :id="'names'+item.id" @dblclick="editMode(item.id,'names')" @blur="blurMode(item.id,'names')" @keyup.enter="blurMode(item.id,'names')" readonly/>
        </template>
        <template v-slot:item.phone="{ item }">
          <input type="text" style="width: auto;" :value="item.phone" :id="'phone'+item.id" @dblclick="editMode(item.id,'phone')" @blur="blurMode(item.id,'phone')" @keyup.enter="blurMode(item.id,'phone')" readonly/>
        </template>
        <template v-slot:item.email="{ item }">
          <input type="text" style="width: auto;" :value="item.email" :id="'email'+item.id" @dblclick="editMode(item.id,'email')" @blur="blurMode(item.id,'email')" @keyup.enter="blurMode(item.id,'email')" readonly/>
        </template>
        <template v-slot:item.address="{ item }">
          <input type="text" style="width: auto;" :value="item.address" :id="'address'+item.id" @dblclick="editMode(item.id,'address')" @blur="blurMode(item.id,'address')" @keyup.enter="blurMode(item.id,'address')" readonly/>
        </template>
        <template v-slot:item.privilege="{ item }">
          <input type="text" style="width: 400px;" :value="item.privilege" :id="'privilege'+item.id" @dblclick="onModal(item.id,'privilege')" readonly/>
        </template>
        <template v-slot:item.country="{ item }">
          <input type="text" style="width: auto;" :value="item.country" :id="'country'+item.id" @dblclick="onModal(item.id,'country')" readonly/>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon :color="'#0a43ae'" @click="deleteStaff(item.id,item.names)">delete</v-icon>
        </template>
        <template v-slot:top>
          <v-toolbar
            flat
          >
            <v-toolbar-title>Staff</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="mb-2"
              @click="callModal"
              style="text-transform: none;"
            >
              New Staff
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mt-2"
            @click="edit(item),state='edit'"
          >
          </v-icon>
        </template>
      </v-data-table>
    </v-app>
    <vue-confirm-dialog></vue-confirm-dialog>
  </div>
</template>
<script>
import {
  mdiAccount,
  mdiPencil,
  mdiShareVariant,
  mdiDelete,
} from '@mdi/js'
import NewStaff from './NewStaff'
import Swal from "sweetalert2"
export default {
  components: {
    NewStaff,
  },
  data: () => ({
    icons: {
      mdiAccount,
      mdiPencil,
      mdiShareVariant,
      mdiDelete,
    },
    headers: [
      { text: '#', value: 'id' },
      { text: 'Names', value: 'names' },
      { text: 'Phone', value: 'phone' },
      { text: 'Email', value: 'email' },
      { text: 'Address', value: 'address' },
      { text: 'Post', value: 'privilege' },
      { text: 'Country', value: 'country' },
      { text: '', value: 'action' },
    ],
    date: new Date().toISOString().substr(0, 7),
    modal: false,
    dialogModal: false,
    modal2: null,
    logger: [],
    header: '',
    privilege: null,
    country: null,
    state: '',
    staffId: '',
    cId: '',
    showup: false,
    staff: [],
    selected: [],
    countries: ['Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua And Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia, Plurinational State Of', 'Bonaire, Sint Eustatius And Saba', 'Bosnia And Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo DRC', 'Cook Islands', 'Costa Rica', "Côte D'ivoire", 'Croatia', 'Cuba', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-bissau', 'Guyana', 'Haiti', 'Heard Island And Mcdonald Islands', 'Holy See (vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic Of', 'Iraq', 'Ireland', 'Isle Of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', "Korea, Democratic People's Republic Of", 'Korea, Republic Of', 'Kuwait', 'Kyrgyzstan', "Lao People's Democratic Republic", 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia, The Former Yugoslav Republic Of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States Of', 'Moldova, Republic Of', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine, State Of', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Barthélemy', 'Saint Helena, Ascension And Tristan Da Cunha', 'Saint Kitts And Nevis', 'Saint Lucia', 'Saint Martin (french Part)', 'Saint Pierre And Miquelon', 'Saint Vincent And The Grenadines', 'Samoa', 'San Marino', 'Sao Tome And Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten (dutch Part)', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia And The South Sandwich Islands', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard And Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan, Province Of China', 'Tajikistan', 'Tanzania, United Republic Of', 'Thailand', 'Timor-leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad And Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks And Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela, Bolivarian Republic Of', 'Viet Nam', 'Virgin Islands, British', 'Virgin Islands, U.s.', 'Wallis And Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'],
    totalDesserts: 0,
    desserts: [],
    loading: true,
    options: {},
    valid: true,
    appear: false,
    posts: [],
  }),

  watch: {
    options: {
      handler () {
        this.fakeApiCall()
      },
      deep: true,
    },
  },
  created () {
    this.fetchStaff()
  },
  methods: {
    editMode: function (id, key) {
      var staff = document.getElementById(key + '' + id)
      staff.focus()
      staff.readOnly = false
      staff.classList.add('editMode')
    },
    blurMode (id, key) {
      var staff = document.getElementById(key + '' + id)
      staff.readOnly = true
      staff.classList.remove('editMode')
      this.editStaff(id, key, staff.value)
    },
    async editStaff (id, key, value) {
      if (localStorage.getItem('logged_user')) { this.logger = JSON.parse(localStorage.getItem('logged_user')) }
      this.header = this.logger.accessToken
      const data = {
        id: id,
        key: key,
        value: value,
      }
      try {
        await this.axios({
          url: 'manipulate_staff/1',
          method: 'post',
          data: data,
          headers: {
            Authorization: 'Bearer ' + this.header,
          },
        })
      } catch (e) {
        if (e.response && e.response.status === 403) {
          console.log(e)
        } else {
          console.log(e)
        }
      }
    },
    async fetchStaff (start, end) {
      this.loading = true
      if (localStorage.getItem('logged_user')) {
        this.logger = JSON.parse(localStorage.getItem('logged_user'))
      }
      this.header = this.logger.accessToken
      try {
        const response = await this.axios({
          url: 'get_staff/' + start + '/' + end,
          method: 'get',
          headers: {
            Authorization: 'Bearer ' + this.header,
          },
        })
        if (response.status === 200) {
          this.loading = false
          this.desserts = response.data.staff
          this.totalDesserts = parseInt(response.data.total)
          return response.data.staff
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$router.push({ name: 'login-page' })
        } else if (error.response && error.response.status === 400) {
          this.loading = false
        } else {
          console.log(error)
        }
      }
    },
    fakeApiCall () {
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let items = this.fetchStaff((page - 1) * itemsPerPage, itemsPerPage)
        const total = this.desserts.length
        if (sortBy.length === true && sortDesc.length === true) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy[0]]
            const sortB = b[sortBy[0]]
            if (sortDesc[0]) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }
        if (itemsPerPage > 0) {
          this.desserts = this.desserts.slice((page - 1) * itemsPerPage, page * itemsPerPage)
        }
        setTimeout(() => {
          resolve({
            items,
            total,
          })
        }, 1000)
      })
    },
    async fetchSelectedPosts () {
      if (localStorage.getItem('logged_user')) {
        this.logger = JSON.parse(localStorage.getItem('logged_user'))
      }
      this.header = this.logger.accessToken
      try {
        const res = await this.axios({
          url: 'get_selected_post',
          method: 'get',
          headers: {
            Authorization: 'Bearer ' + this.header,
          },
        })
        if (res.status === 200) {
          this.posts = res.data
          console.log(res.data)
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$router.push({ name: 'login-page' })
        } else {
          console.log(error)
        }
      }
    },
    callModal () {
      this.showup = true
    },
    cancel (event) {
      this.showup = event
    },
    getData (event) {
      this.appear = true
      this.desserts.push(event)
    },
    async fetchSelectedStaff () {
      if (localStorage.getItem('logged_user')) {
        this.logger = JSON.parse(localStorage.getItem('logged_user'))
      }
      this.header = this.logger.accessToken
      try {
        const res = await this.axios({
          url: 'get_selected_post',
          method: 'get',
          headers: {
            Authorization: 'Bearer ' + this.header,
          },
        })
        if (res.status === 200) {
          this.selected = res.data
          console.log(res.data)
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$router.push({ name: 'login-page' })
        } else {
          console.log(error)
        }
      }
    },
    onModal (id, key) {
      if (key === 'privilege') {
        this.fetchSelectedStaff()
        this.staffId = id
        this.dialogModal = true
      } else if (key === 'country') {
        this.cId = id
        this.modal2 = true
      }
    },
    offModal () {
      this.dialogModal = false
    },
    async edit (key) {
      let id = 0
      let value = ''
      if (key === 'privilege') {
        id = this.staffId
        value = this.privilege
      } else if (key === 'country') {
        id = this.cId
        value = this.country
      }
      if (localStorage.getItem('logged_user')) { this.logger = JSON.parse(localStorage.getItem('logged_user')) }
      this.header = this.logger.accessToken
      const data = {
        id: id,
        key: key,
        value: value,
      }
      try {
        const response = await this.axios({
          url: 'manipulate_staff/1',
          method: 'post',
          data: data,
          headers: {
            Authorization: 'Bearer ' + this.header,
          },
        })
        if (response.status === 200) {
          this.fakeApiCall()
          if (key === 'privilege') {
            this.privilege = ''
            this.dialogModal = false
          } else if (key === 'country') {
            this.country = ''
            this.modal2 = false
          }
        }
      } catch (e) {
        if (e.response && e.response.status === 403) {
          console.log(e)
        } else {
          console.log(e)
        }
      }
    },
    quitModal () {
      this.modal2 = false
    },
    deleteStaff (id, title) {
      this.$confirm(
        {
          message: 'Delete ' + ' ' + title + ' ' + 'from list ?',
          button: {
            no: 'No',
            yes: 'Yes',
          },
          /**
           * Callback Function
           * @param {Boolean} confirm
           */
          callback: async confirm => {
            if (confirm) {
              // ... do something
              if (localStorage.getItem('logged_user')) {
                this.logger = JSON.parse(localStorage.getItem('logged_user'))
              }
              this.header = this.logger.accessToken
              try {
                const res = await this.axios({
                  url: 'delete_staff',
                  method: 'post',
                  data: {
                    id: id,
                  },
                  headers: {
                    Authorization: 'Bearer ' + this.header,
                  },
                })
                if (res.status === 200) {
                  this.desserts = this.desserts.filter(staff => staff.id !== id)
                  this.loading = false
                  this.fakeApiCall()
                }
              } catch (error) {
                if (error.response && error.response.status === 401) {
                  this.$router.push({ name: 'login-page' })
                }
                if (error.response && error.response.status === 400) {
                  Swal.fire({
                    title: 'Error!',
                    text: error.response.data.message,
                    icon: 'error',
                    confirmButtonText: 'Ok',
                  })
                  this.loading = false
                } else {
                  console.log(error)
                }
              }
            }
          },
        },
      )
    },
  },
}
</script>
<style scoped>
  .editMode {
    padding: 3px;
    background-color: #fdf9ff;
    font-size: 14px;
    border: 1px solid;
    border-radius: 3px;
  }
</style>
